import { dataSelector } from '@nextiva/global-store';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';

import { postLicenseOrder } from 'services/licensePricingData/licensePricingDataService';
import { processLicenseOrderPayloadType } from 'types/purchaseLicenseModalTypes';
import { GlobalStoreInterface } from 'interface/globalStore';

export const useProcessLicenseOrder = (licenseDetailId: string) => {
  const globalStoreData: GlobalStoreInterface | undefined = useSelector(
    dataSelector,
  );
  const sso: string = globalStoreData?.sso;
  const corpAccountNumber: string =
    globalStoreData?.user?.accountInfo?.corpAcctNbr ??
    globalStoreData?.user?.profileDTO?.corpAcctNbr;

  return useMutation((payload: processLicenseOrderPayloadType) =>
    postLicenseOrder(payload, sso, corpAccountNumber, licenseDetailId),
  );
};
